<template>
    <div id="input-fields">
        <md-field id="email-field" v-if="activFields.email">
            <label 
                :class="{error: errMessages.emailErrMsg || message,
                        done: doneState && !message}"
                class="p1n px-2">
                    Enter your email
            </label>
            <md-input 
                id="email-input"
                @keyup.enter="handleEnter" 
                class="p1n" 
                :class="{errState: errMessages.emailErrMsg || message, doneState: doneState}"
                :change="onEmailConfirmed(email)"
                v-model="email" 
                type="email"
                autocomplete="off"
                @blur="checkEmailValidation(email)"/>
            <div id="email-err-done-state-icon" class="err-done-img">
                <img v-if="doneState && !message"
                    :src="ICON_CHECKMARK"
                    alt="">
                <img v-else-if="errMessages.emailErrMsg || message"
                    :src="ICON_WARNING"
                    alt="">
            </div>
            <div id="email-err-message" class="err-box">
                <span v-if="errMessages.emailErrMsg" class="c5o7 lab">
                    Please enter a valid email address
                </span>
            </div>
        </md-field>

        <md-field id="pass-field" v-if="activFields.password">
            <label 
                :class="{error: errMessages.passErrMsg || message , 
                done: doneStatePass && !message}"
                class="p1n px-2">
                    Enter your new password
            </label>
            <md-input 
                id="pass-input"
                @keyup.enter="handleEnter" 
                :class="{errState: errMessages.passErrMsg || message, doneState: doneStatePass}"
                :change="onPassConfirmed(password)"
                @blur="checkPassValidation(password)" 
                v-model="password" 
                class="p1n" 
                autocomplete="new-password"
                type="password"/>
            <div id="pass-err-done-state-icon" class="err-done-img">
                <img v-if="doneStatePass && !message"
                    :src="ICON_CHECKMARK"
                    alt="">
                <img v-else-if="errMessages.passErrMsg || message"
                    :src="ICON_WARNING"
                    alt="">
            </div>
            <div id="pass-err-message" class="err-box mt-1">
                <p v-if="errMessages.passErrMsg" class="c5o7 lab">
                    Minimum 6 alphanumeric characters, with at least 1 digit. 
                </p>
            </div>
        </md-field>

        <md-field v-if="activFields.confirmPass">
            <label 
                :class="{error: errMessages.confpassErrMsg ,
                done: doneStateConfPass}" 
                class="p1n px-2">
                    Confirm your new password
            </label>
            <md-input 
                @keyup.enter="handleEnter" 
                    :class="{errState: errMessages.confpassErrMsg, doneState: doneStateConfPass}"
                    :change="checkConfirmPassValidation(confirmPassword)" 
                    v-model="confirmPassword"
                    class="p1n" 
                    type="password"/>
            <div class="err-done-img">
                <img v-if="doneStateConfPass"
                    :src="ICON_CHECKMARK"
                    alt="">
                <img v-else-if="errMessages.confpassErrMsg"
                    :src="ICON_WARNING"
                    alt="">
            </div>
            <div class="err-box pt-1">
                <p v-if="errMessages.confpassErrMsg" class="c5o7 lab">
                   Passwords do not match
                </p>
            </div>
        </md-field>

    </div>

</template>

<script>
    import {
        mapState
    } from 'vuex'
    import {
        ICON_WARNING,
        ICON_CHECKMARK
    } from "../../constants";

    export default {
        name: "EmailInput",
        props: {
            activFields: Object,
            onNameConfirmed: Function,
            onEmailConfirmed: Function,
            onPassConfirmed: Function,
            onConfirmPass: Function,
            storeMessage: Object,
            onSubmit: Function
        },

        data() {
            return {
                ICON_WARNING,
                ICON_CHECKMARK,
                errMessages: {},
                doneStatePass: false,
                doneState: false,
                doneStateConfPass: false,
                email: '',
                password: '',
                confirmPassword: '',
                name: '',
            }
        },
        computed: {
            ...mapState([
                'message'
            ])
        },
        methods: {
            handleEnter(){
                this.onSubmit();
            },
            checkEmailValidation(val) {
                let re = /\S+@\S+\.\S+/;
                if (re.test(val)) {
                    this.errMessages = {
                        ...this.errMessages,
                        emailErrMsg: null
                    }
                    this.onEmailConfirmed(val);
                    this.doneState = true;
                    this.$emit('emailDone', true)
                    return true;
                } else {
                    if(val && val.length) {
                        this.errMessages = {
                            ...this.errMessages,
                            emailErrMsg: "Something went wrong. Try again!"
                        }
                        this.onEmailConfirmed(null);
                        this.doneState = false;
                        this.$emit('emailDone', false)
                        return false;
                    }
                }
            },
            checkPassValidation(val) {
                let re = /^(?=.*[a-z])(?=.*\d)(?=.*).{6}/;
                if (re.test(val)) {
                    this.errMessages = {
                        ...this.errMessages,
                        passErrMsg: null
                    }
                    this.onPassConfirmed(val);
                    this.doneStatePass = true;
                    this.$emit('passwordDone', true)
                    return true;
                } else {
                    if(val && val.length) {
                        this.errMessages = {
                            ...this.errMessages,
                            passErrMsg: "Password has less 6"
                        }
                        this.onPassConfirmed(null);
                        this.$emit('passwordDone', false)
                        this.doneStatePass = false;
                        return false;
                    }
                }
            },
            checkConfirmPassValidation(val) {
                
                if (!val || val.length < 3 || this.password !== this.confirmPassword) {
                    this.onConfirmPass(null, null);
                    if(val.length >3) {

                        this.errMessages.confpassErrMsg = 'null';
                    }
                    this.doneStateConfPass = false;
                    return true;
                }
                
                let re = /^(?=.*[a-z])(?=.*\d)(?=.*).{6}/;
                if (re.test(val)) {
                    this.errMessages.confpassErrMsg = null;
                    this.onConfirmPass(val);
                    this.doneStateConfPass = true;
                    return true;
                } else {
                    this.errMessages.confpassErrMsg = "Password has less 6";
                    this.onConfirmPass(null);
                    this.doneStateConfPass = false;
                    return false;
                }
            },
        },
    }
</script>
<style>
.md-field.md-has-password .md-toggle-password {
    right: 7px !important;
}
</style>
<style scoped>

    label.error {
        color: #fa5c7cb3 !important;
    }

    label.done {
        color: #0ACF97 !important;
    }

    .err-box {
        position: absolute;
        top: 100%;
        left: 0px;
    }

    .err-box p {
        line-height: 1.2;
    }


    .err-done-img {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(30px, -8px);
    }

    .md-input {
        height: 48px !important;
        border: 1px solid #C7C4C4 !important;
        box-sizing: border-box;
        border-radius: 5px;
        padding-left: 10px !important;
    }

    .md-input.doneState {
        border: 1px solid #0ACF97 !important;
    }

    .md-input.errState {
        border: 1px solid #fa5c7cb3 !important;
    }

    .md-field label {
        position: absolute;
        top: 50%;
        left: 11px;
        pointer-events: none;
        transform: translateY(-35%);
        transition: .4s cubic-bezier(.25, .8, .25, 1);
        transition-duration: .3s;
        font-size: 13px;
        line-height: 20px;
        margin: 0;
        z-index: 2;
        background-color: #fff !important;
    }

    .md-field.md-focused label,
    .md-field.md-has-value label {
        pointer-events: auto;
        top: 5px;
        opacity: 1;
        font-size: 12px;
        display: block;
        background-color: #fff !important;
    }

    .md-field {
        width: 100%;
        min-height: 48px;
        padding-top: 8px;
        display: flex;
        position: relative;
        font-family: inherit;
    }

    .md-field.md-theme-default::after,
    .md-field.md-theme-default:before {
        background-color: transparent;
        content: none !important;
    }
</style>